module.exports = __webpack_public_path__ + "static/media/user.b3a74e3a.svg";